export default __webpack_public_path__ + "static/media/cctvimage2.d9468bb1.jfif";